import { observer } from 'mobx-react';
import EditGroupStore from '../../../../EditGroupStore';
import GroupMetadataSection from '../Shared/GroupMetadataSection';
import GroupLicenseSelectionSection from '../Shared/GroupLicenseSelectionSection';
import GroupCollectionsSection from '../Shared/GroupCollectionsSection';

interface Props {
  editGroupStore: EditGroupStore;
}

/**
 * Edit Group form, restyled to the Add Group section-card language
 * (DVLP-6751). Renders the same shared section components Add Group uses,
 * wired to EditGroupStore's adapters. Save/validation errors surface as a
 * banner above the sections, matching Add Group (Edit Group previously showed
 * them inline under the name/description fields).
 */
function EditGroupForm({ editGroupStore }: Props) {
  return (
    <div className="space-y-6">
      {editGroupStore.formError
        .map((message) => (
          <div className="border border-destructive/40 bg-destructive/10 text-destructive rounded-md p-4">
            {message}
          </div>
        ))
        .getOrElseValue(<></>)}

      <GroupMetadataSection
        name={editGroupStore.name}
        description={editGroupStore.description}
        active={editGroupStore.active}
        onNameChange={editGroupStore.updateName}
        onDescriptionChange={editGroupStore.updateDescription}
        onActiveChange={editGroupStore.setActive}
        sectionNumber={1}
      />

      <GroupLicenseSelectionSection
        licenses={editGroupStore.licenses}
        selectedLicenseIds={editGroupStore.selectedLicenseIds}
        onSelectedLicenseIdsChange={editGroupStore.setSelectedLicenseIds}
        licenseSearchQuery={editGroupStore.licenseSearchQuery}
        onLicenseSearchQueryChange={editGroupStore.setLicenseSearchQuery}
        expandedLicenseTypes={editGroupStore.expandedLicenseTypes}
        onToggleLicenseTypeExpanded={editGroupStore.toggleLicenseTypeExpanded}
        sectionNumber={2}
      />

      <GroupCollectionsSection
        collections={editGroupStore.collections}
        selectedCollectionIds={editGroupStore.selectedCollectionIds}
        onSelectedCollectionIdsChange={editGroupStore.setSelectedCollectionIds}
        sectionNumber={3}
      />
    </div>
  );
}

export default observer(EditGroupForm);
